// Imports
import DemoMainDefault from "../pages/demos/DemoMainDefault"
import DemoMainLarge from "../pages/demos/DemoMainLarge"
import DemoMainForm from "../pages/demos/DemoMainForm"
import DemoAsideLeft from "../pages/demos/DemoAsideLeft"
import DemoAsideRight from "../pages/demos/DemoAsideRight"
import DemoContainerBothSides from "../pages/demos/DemoContainerBothSides"

import DemoCoverCenter from "../pages/demos/DemoCoverCenter"
import DemoCoverCenterOverlay from "../pages/demos/DemoCoverCenterOverlay"
import DemoCoverBottom from "../pages/demos/DemoCoverBottom"
import DemoCoverBottomOverlay from "../pages/demos/DemoCoverBottomOverlay"

import DemoPageLoading from "../pages/demos/DemoPageLoading"

import DemoHeaderPlainPrimary from "../pages/demos/DemoHeaderPlainPrimary"
import DemoHeaderPlainWhite from "../pages/demos/DemoHeaderPlainWhite"
import DemoHeaderTransparentPrimary from "../pages/demos/DemoHeaderTransparentPrimary"
import DemoHeaderTransparentWhite from "../pages/demos/DemoHeaderTransparentWhite"

import DemoFooter from "../pages/demos/DemoFooter"
import DemoFooterSeparator from "../pages/demos/DemoFooterSeparator"

const routeDemos = [
    {
        path: "/layouts/container/demo-main-default",
        element: DemoMainDefault,
    },
    {
        path: "/layouts/container/demo-main-large",
        element: DemoMainLarge,
    },
    {
        path: "/layouts/container/demo-main-form",
        element: DemoMainForm,
    },
    {
        path: "/layouts/container/demo-aside-left",
        element: DemoAsideLeft,
    },
    {
        path: "/layouts/container/demo-aside-right",
        element: DemoAsideRight,
    },
    {
        path: "/layouts/container/demo-aside-both-sides",
        element: DemoContainerBothSides,
    },

    {
        path: "/components/cover/demo-center",
        element: DemoCoverCenter,
    },
    {
        path: "/components/cover/demo-center-overlay",
        element: DemoCoverCenterOverlay,
    },
    {
        path: "/components/cover/demo-bottom",
        element: DemoCoverBottom,
    },
    {
        path: "/components/cover/demo-bottom-overlay",
        element: DemoCoverBottomOverlay,
    },

    {
        path: "/components/page-loading/demo",
        element: DemoPageLoading,
    },

    {
        path: "/components/header/demo-plain-primary",
        element: DemoHeaderPlainPrimary,
    },
    {
        path: "/components/header/demo-plain-white",
        element: DemoHeaderPlainWhite,
    },
    {
        path: "/components/header/demo-transparent-primary",
        element: DemoHeaderTransparentPrimary,
    },
    {
        path: "/components/header/demo-transparent-white",
        element: DemoHeaderTransparentWhite,
    },

    {
        path: "/components/footer/demo",
        element: DemoFooter,
    },
    {
        path: "/components/footer/demo-separator",
        element: DemoFooterSeparator,
    },
]

export default routeDemos
